import { render, staticRenderFns } from "./giftManagement.vue?vue&type=template&id=646ecd00&scoped=true"
import script from "./giftManagement.vue?vue&type=script&lang=js"
export * from "./giftManagement.vue?vue&type=script&lang=js"
import style0 from "./giftManagement.vue?vue&type=style&index=0&id=646ecd00&prod&lang=css"
import style1 from "./giftManagement.vue?vue&type=style&index=1&id=646ecd00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ecd00",
  null
  
)

export default component.exports